<template>
  <div>
    <pbas-data-table
      ref="table"
      :dataProvider="provider"
      :rowActions="rowActions"
      :floatActions="floatActions"
      sortBy="Name"
      :exporters="$exporters"
      @error="error = $event"
      :showSelect="false"
    ></pbas-data-table>

    <invoice-view-dialog
      v-if="selectedId !== null && selectedId !== undefined"
      :model="viewDialog"
      :id="selectedId"
      @close="
        viewDialog = false;
        selectedId = null;
      "
    ></invoice-view-dialog>
    <new-invoice-dialog
      :billingPeriods="billingPeriods"
      :planIdentityId="planIdentityId"
      :model="addDialog"
      @close="onClose"
    />
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="warningDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          {{ $t("globals.warning") }}
          <!--TODO: check translations if exist-->
        </v-card-title>
        <v-card-text>
          {{ $t("components.invoices.invoices_table.warning_text") }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="warningDialog = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <error-handler :error="error" />
    <v-snackbar v-model="success" color="success" :timeout="2500">
      {{ $t("globals.success") }}
      <v-btn dark text @click="success = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import getHeaders from "@/headers/Invoices";
import { ODataProvider } from "pbas-vue-components";
import { mapGetters, mapActions } from "vuex";
import InvoiceViewDialog from "./InvoiceViewDialog.vue";
import ErrorHandler from "@/components/ErrorHandler";
import NewInvoiceDialog from "./NewInvoiceDialog.vue";

export default {
  components: {
    ErrorHandler,
    InvoiceViewDialog,
    NewInvoiceDialog,
  },
  props: ["planIdentityId", "actions"],
  data: function() {
    return {
      viewDialog: false,
      provider: undefined,
      error: null,
      rowActions: [
        {
          name: "view",
          icon: "visibility",
          title: "globals.view",
          handler: (item) => {
            console.log("#################################", item);
            this.selectedId = item.Id;
            this.viewDialog = true;
          },
        },
      ],
      selectedId: null,
      addDialog: false,
      success: false,
      loading: false,
      billingPeriods: [],
      warningDialog: false,
    };
  },
  computed: {
    ...mapGetters("common", { settings: "settings" }),
    ...mapGetters("plansMembers", ["options"]),
    floatActions() {
      if (this.actions === true) {
        return [
          {
            name: "add",
            icon: "add",
            color: "#64ba5f",
            text: "globals.add_new",
            handler: this.newInvoice,
          },
        ];
      }
      return [];
    },
  },
  watch: {
    planIdentityId: {
      handler(v) {
        if (v) {
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  //TODO create a watcher for the planIdentityId the every time it changes it loads the table again
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions("plansMembers", ["getBillingPeriodsWithoutInvoices"]),
    loadData() {
      const url =
        this.settings.APIURL + "plans/" + this.planIdentityId + "/invoices";

      this.provider = new ODataProvider(
        this.$axiosHttp,
        url,
        getHeaders(this.options.Enums.InvoiceCategory)
      );
      if (this.$refs.table !== null && this.$refs.table !== undefined) {
        this.$refs.table.getDataAsync();
      }
    },
    async newInvoice() {
      this.loading = true;
      try {
        this.billingPeriods = (await this.getBillingPeriodsWithoutInvoices({
          planIdentityId: this.planIdentityId,
        })).data;
        if (
          this.billingPeriods !== null &&
          this.billingPeriods !== undefined &&
          this.billingPeriods.length > 0
        ) {
          this.addDialog = true;
        } else {
          this.warningDialog = true;
        }
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    onClose(data) {
      this.addDialog = false;
      if (data!==null) {
        this.$refs.table.getDataAsync();
      }
    },
  },
};
</script>
